import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import { Field } from '../types/GenericFormTypes';
import { makeParser } from './makeParser';
import { makeFormatter } from './makeFormatter';
import { validEmailaddress } from './validators';

/** Used for `GenericForm`, add default parse, format and validator to each field */
export const makeGenericFormFields = (fields: Field[]) => {
  return fields.map((f) => {
    const yearOnlySchema = (f as Field<string, 'date'>).yearOnly
      ? JSON.stringify({ type: 'string', format: FORMAT_C3_YEAR_DATE })
      : undefined;
    return {
      ...f,
      parse: f.parse ?? makeParser(f.type, yearOnlySchema),
      format: f.format ?? makeFormatter(f.type, yearOnlySchema),
      validate: f.validate ?? getValidator(f)
    };
  });
};

/** Add default validator based on field type, except required validator, because it will be added in `useGenericFormState`  */
const getValidator = (field: Field) => {
  switch (field?.type) {
    case 'email':
      return validEmailaddress;

    default:
      return null;
  }
};
